import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import { Button } from '@/components/ui/Button';

export const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const { isImpersonating, impersonatedUser, stopImpersonation, isLoading } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  return (
    <div className="bg-yellow-500 text-black px-4 py-3 shadow-lg">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
          <UserIcon className="h-5 w-5" />
          <span className="font-medium">
            {t('youAreImpersonating')}{' '}
            <strong>
              {impersonatedUser.firstName} {impersonatedUser.lastName}
            </strong>{' '}
            ({impersonatedUser.email})
          </span>
        </div>
        <Button
          onClick={stopImpersonation}
          disabled={isLoading}
          variant="outline"
          className="bg-white hover:bg-neutral-100 text-black border-black"
        >
          <ArrowLeftIcon className="h-4 w-4 ltr:me-2 rtl:ms-2" />
          {isLoading ? t('returning') : t('returnToAdmin')}
        </Button>
      </div>
    </div>
  );
};
